import { PASSWORD_MIN_LENGTH } from "./constants";

export const hasMinimumLength = (password) => {
    return password && password.length >= PASSWORD_MIN_LENGTH;
};

export const charTypeHasLowerCase = (password) => {
    return /[a-z]/.test(password);
};

export const charTypeHasUpperCase = (password) => {
    return /[A-Z]/.test(password);
};

export const charTypeHasNumbers = (password) => {
    return /[0-9]/.test(password);
};

export const charTypeHasSpecialChars = (password) => {
    // Source: https://owasp.org/www-community/password-special-characters
    return /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(password);
};

export const countCharacterTypes = (password) => {
    let count = 0;
    if (charTypeHasLowerCase(password)) count++;
    if (charTypeHasUpperCase(password)) count++;
    if (charTypeHasNumbers(password)) count++;
    if (charTypeHasSpecialChars(password)) count++;
    return count;
};

export const hasEnoughCharacterTypes = (password) => {
    return countCharacterTypes(password) >= 4;
};

export const areAllRequirementsMet = (password) => {
    return hasMinimumLength(password) && hasEnoughCharacterTypes(password);
};
